import { render, staticRenderFns } from "./mr_open.vue?vue&type=template&id=62104d52"
import script from "./mr_open.vue?vue&type=script&lang=js"
export * from "./mr_open.vue?vue&type=script&lang=js"
import style0 from "./mr_open.vue?vue&type=style&index=0&id=62104d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports